/* Viretta – cart-value discount banner + segmented progress bar for the Bluecart progress-bar app.
   Rewritten 8 Oct 2026 from the inline script in the old layout: same markup and classes,
   no console logs, no calls to undefined functions, one debounced refresh. */
(() => {
  if (window.VirettaCartRewards) return;
  window.VirettaCartRewards = true;

  const STORAGE_KEY = 'discountBannerClosed';
  const BANNER_HTML = `
    <div class="discount-banner">
      <div class="discount-icon">
        <img src="https://cdn.shopify.com/s/files/1/0807/5427/8733/files/app-block.svg?v=1762260767" alt="" width="40" height="40" loading="lazy">
      </div>
      <div class="discount-content">
        <div class="discount-header">
          <h4 class="discount-title">Sæsonens største fordel</h4>
          <span class="discount-info" data-tooltip="Jo mere du køber, desto større bliver din rabat og dine belønninger.">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" aria-hidden="true"><path d="M9.16824 0C14.2319 0 18.3365 4.10462 18.3365 9.16824C18.3365 14.2319 14.2319 18.3365 9.16824 18.3365C4.10462 18.3365 0 14.2319 0 9.16824C0 4.10462 4.10462 0 9.16824 0ZM9.16824 1.83365C7.22299 1.83365 5.35741 2.6064 3.9819 3.9819C2.6064 5.35741 1.83365 7.22299 1.83365 9.16824C1.83365 11.1135 2.6064 12.9791 3.9819 14.3546C5.35741 15.7301 7.22299 16.5028 9.16824 16.5028C11.1135 16.5028 12.9791 15.7301 14.3546 14.3546C15.7301 12.9791 16.5028 11.1135 16.5028 9.16824C16.5028 7.22299 15.7301 5.35741 14.3546 3.9819C12.9791 2.6064 11.1135 1.83365 9.16824 1.83365ZM9.16824 12.8355C9.4114 12.8355 9.6446 12.9321 9.81654 13.1041C9.98847 13.276 10.0851 13.5092 10.0851 13.7524C10.0851 13.9955 9.98847 14.2287 9.81654 14.4007C9.6446 14.5726 9.4114 14.6692 9.16824 14.6692C8.92509 14.6692 8.69189 14.5726 8.51995 14.4007C8.34801 14.2287 8.25142 13.9955 8.25142 13.7524C8.25142 13.5092 8.34801 13.276 8.51995 13.1041C8.69189 12.9321 8.92509 12.8355 9.16824 12.8355ZM9.16824 4.12571C9.94047 4.12573 10.6886 4.39466 11.2841 4.88631C11.8796 5.37795 12.2853 6.06162 12.4315 6.81987C12.5777 7.57812 12.4553 8.36363 12.0854 9.04146C11.7154 9.71929 11.121 10.2471 10.4041 10.5343C10.2979 10.5734 10.2022 10.6364 10.1245 10.7186C10.0842 10.7644 10.0777 10.8231 10.0787 10.8836L10.0851 11.0019C10.0848 11.2356 9.99533 11.4603 9.83492 11.6303C9.6745 11.8002 9.45525 11.9024 9.22198 11.9161C8.9887 11.9298 8.75899 11.8539 8.5798 11.7039C8.4006 11.554 8.28544 11.3412 8.25784 11.1092L8.25142 11.0019V10.7727C8.25142 9.71559 9.10407 9.08115 9.72201 8.83269C9.9735 8.73226 10.1929 8.56522 10.3566 8.34951C10.5203 8.1338 10.6222 7.87756 10.6513 7.60832C10.6804 7.33908 10.6356 7.067 10.5217 6.8213C10.4078 6.57561 10.2291 6.36557 10.0049 6.21376C9.78063 6.06194 9.51926 5.97408 9.24884 5.95961C8.97842 5.94513 8.70916 6.00459 8.46999 6.1316C8.23081 6.25861 8.03075 6.44838 7.89129 6.68051C7.75182 6.91265 7.67823 7.17839 7.6784 7.4492C7.6784 7.69236 7.58181 7.92555 7.40987 8.09749C7.23794 8.26943 7.00474 8.36602 6.76158 8.36602C6.51842 8.36602 6.28523 8.26943 6.11329 8.09749C5.94135 7.92555 5.84476 7.69236 5.84476 7.4492C5.84476 6.56775 6.19491 5.72241 6.81818 5.09914C7.44146 4.47586 8.2868 4.12571 9.16824 4.12571Z" fill="#7D8487"/></svg>
          </span>
        </div>
        <p class="discount-dates">Begynd din samling og se din fordel vokse: Spar op til 30% + få en gave.</p>
      </div>
      <button type="button" class="discount-close" aria-label="Luk">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M19.24 19.2617L12.0379 12.0596L5.25928 5.26172" stroke="#161819" stroke-width="2.54199" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.25998 19.2617L12.4621 12.0596L19.2407 5.26172" stroke="#161819" stroke-width="2.54199" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>`;

  const isClosed = () => { try { return localStorage.getItem(STORAGE_KEY) === 'true'; } catch (e) { return false; } };
  const setClosed = (closed) => { try { if (closed) localStorage.setItem(STORAGE_KEY, 'true'); else localStorage.removeItem(STORAGE_KEY); } catch (e) { /* storage blocked */ } };

  /* One banner in front of each Bluecart progress bar, never twice. */
  const addBanners = () => {
    document.querySelectorAll('.progress-bar-container').forEach((bar) => {
      if (bar.dataset.virettaBanner) return;
      bar.dataset.virettaBanner = '1';
      bar.insertAdjacentHTML('beforebegin', BANNER_HTML);
      if (isClosed()) bar.previousElementSibling?.classList.add('show-only-icon');
    });
  };

  /* Split the app's single progress fill into one fill per milestone segment. */
  const fillSegments = () => {
    document.querySelectorAll('.progress-bar-container').forEach((container) => {
      const bar = container.querySelector('.progress-bar');
      const progress = container.querySelector('.progress-bar-progress');
      if (!bar || !progress) return;
      const items = Array.from(bar.querySelectorAll('li'));
      if (!items.length) return;
      const total = items.reduce((sum, li) => sum + li.offsetWidth, 0);
      const w = progress.style.width.trim();
      let remaining = w.endsWith('%') ? (parseFloat(w) / 100) * total : w.endsWith('px') ? parseFloat(w) : 0;
      items.forEach((li) => {
        let fill = li.querySelector(':scope > .li-progress');
        if (!fill) {
          fill = document.createElement('div');
          fill.className = 'li-progress';
          Object.assign(fill.style, { position: 'absolute', left: '0', top: '0', height: '100%', background: 'rgb(75 93 103)', transition: 'width 0.5s ease', borderRadius: '24px', width: '0px' });
          li.style.position = 'relative';
          li.style.overflow = 'hidden';
          li.prepend(fill);
        }
        const take = Math.max(0, Math.min(remaining, li.offsetWidth));
        fill.style.width = `${take}px`;
        remaining -= take;
      });
    });
  };

  let timer;
  const refresh = (delay = 300) => {
    clearTimeout(timer);
    timer = setTimeout(() => { addBanners(); fillSegments(); }, delay);
  };

  /* The app renders its bar after load and re-renders it when the cart changes. */
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes') {
        if (m.target.classList && m.target.classList.contains('progress-bar-progress')) { refresh(100); return; }
        continue;
      }
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (node.matches('.progress-bar-container, .progress-bar-progress') || node.querySelector('.progress-bar-container'))) { refresh(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

  ['cart:change', 'cart:refresh', 'cart:updated'].forEach((evt) => document.addEventListener(evt, () => refresh(500)));

  document.addEventListener('click', (e) => {
    const banner = e.target.closest('.bcpb-bluecart, .discount-banner');
    if (!banner) return;
    if (e.target.closest('.discount-close')) { banner.classList.add('show-only-icon'); setClosed(true); return; }
    if (banner.classList.contains('show-only-icon')) { banner.classList.remove('show-only-icon'); setClosed(false); }
  });

  const start = () => refresh(0);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
